<template>
    <div id="component-promoter-agent">

        <main id="mainContent" class="padFixBoth">
            <div class="row">
                <div class="accordion accordion-flush" id="accordionExample">
                    <div v-for="promoter in promoters" :key="promoter.id" class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                {{ promoter.nmPromotor }}
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                <ul id="agentList">
                                    <li v-for="agent in promoter.relagent">
                                        {{ agent.comisionista }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {reportService} from "../../Services/Reports";

export default {
    name: "promoter_gent",
    data() {
        return {
            promoters: [],
        }
    },
    methods: {
        async index() {
            this.promoters = await reportService.getMany({});

        },

    },
    mounted() {
        reportService.setRoute('api/report-promoter-agent');
        this.index();
    }
}
</script>

<style scoped>
#agentList {
    list-style: none;
    padding: 0;
}

#agentList li {
    padding: 10px;
    border-bottom: 1px solid #ccc;
}

.accordion-button {
    text-transform: uppercase;
}
</style>
